import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";



import ClearFilterButton from "../../../components/Search/clearFilterButton";
import LeftArrow_3 from "../../../assets/img/icons/LeftArrow_3.svg";
import RightArrow_3 from "../../../assets/img/icons/RightArrow_3.svg";
import AddSingleMemberDropdown from "../../../components/CustomDropdown/AddSingleMemberDropdown";
import FilterDropDownStyle from "../../../components/DropdownStyle/FilterDropDownStyle";
import Dropdown from "../../../components/ReactSelectDropdown";
import Select from "../../../components/ReactSelectDropdown";
import { filterOption } from "../../../components/ReactSelectDropdown/ReactSelectDropdown";
import DatePicker from "../../../components/SingleDatePicker/SingleDatePicker";
import { FilterButton } from "../../../styledComponents/buttons";
import {
  CommonFlex,
  FilterLabel,
  IconArrow,
  InputWithLabelSection,
} from "../../../styledComponents/common";
import { JobsInMapFilterContainer } from "../jobsInMapStyles";

const JobsInMapFilter = ({
  selectedOrganization,
  getOrganizationMembersList,
  organizationMembersList,
  selectedMember,
  selectMember,
  clearMember,
  selectedDate,
  singleDateChangeDaily,
  selectToday,
  getOfficesShortList,
  officesShortList,
  selectedOffice,
  selectOffice,
}) => {
  const { t } = useTranslation();
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";

  const [officeOptions, setOfficeOptions] = useState([
    {
      label: `(${t("all_teams")})`,
      value: null,
    },
  ]);

  // Fetch offices and members on org change
  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      getOfficesShortList({ organization_id: selectedOrganization.id });
      getOrganizationMembersList({
        page: 1,
        organization_id: selectedOrganization.id,
        office_id: null,
      });
    }
  }, [selectedOrganization]);

  // Build office options
  useEffect(() => {
    if (officesShortList && officesShortList.length > 1) {
      let newArr = [
        {
          label: `(${t("all_teams")})`,
          value: null,
        },
      ];
      officesShortList.forEach(office => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList, t]);

  // Fetch members when office changes
  useEffect(() => {
    if (selectedOffice?.value && selectedOrganization?.id) {
      getOrganizationMembersList({
        page: 1,
        organization_id: selectedOrganization.id,
        office_id: selectedOffice.value,
      });
    } else if (selectedOrganization?.id) {
      getOrganizationMembersList({
        page: 1,
        organization_id: selectedOrganization.id,
        office_id: null,
      });
    }
  }, [selectedOffice, selectedOrganization]);

  const onMemberSelect = person => {
    selectMember(person);
  };

  const isToday = selectedDate && moment(selectedDate).isSame(moment(), "day");

  const isAdmin =
    localStorage.getItem("selected_organization_role") === "admin" ||
    localStorage.getItem("selected_organization_role") === "owner";

  return (
    <JobsInMapFilterContainer
      columns={
        isOperationType && isAdmin
          ? "auto auto auto 57px 90px"
          : "auto 57px 90px"
      }
    >
      {/* Date Picker */}
      <InputWithLabelSection>
        <FilterLabel>{t("date")}</FilterLabel>
        <CommonFlex gap="4px">
          <DatePicker
            id="jobsInMapFilterDate"
            date={selectedDate}
            onDateChange={date => singleDateChangeDaily(date)}
            placeholder="Select date..."
            allowPreviousDates
            width="200px"
          />
          <CommonFlex gap="4px" margin="1.5px 0 0 0">
            <IconArrow
              onClick={() => singleDateChangeDaily("prev")}
              padding="5px"
              size="40px"
              src={LeftArrow_3}
            />
            <IconArrow
              margin="0 0 0 2px"
              onClick={() => singleDateChangeDaily("next")}
              padding="5px"
              size="40px"
              src={RightArrow_3}
            />
          </CommonFlex>
          <FilterButton
            type="gray"
            padding="10px"
            onClick={selectToday}
            margin="0 0 0 2px"
          >
            Today
          </FilterButton>
        </CommonFlex>
      </InputWithLabelSection>

      {/* Team Filter (for admins/owners) */}
      {/* {isAdmin && isOperationType && (
        <InputWithLabelSection style={{ minWidth: "240px" }}>
          <FilterLabel>{t("team")}</FilterLabel>
          <Dropdown
            isSearchable
            isClearable={selectedOffice?.value}
            value={selectedOffice}
            options={officeOptions}
            placeholder="Select Team..."
            onChange={e => {
              e
                ? selectOffice(e)
                : selectOffice({
                    label: `(${t("all_teams")})`,
                    value: null,
                  });
            }}
            styles={FilterDropDownStyle({ height: "40px" })}
            filterOption={filterOption}
            components={{
              IndicatorSeparator: () => null,
              ClearIndicator: props => <ClearFilterButton {...props} />,
            }}
          />
        </InputWithLabelSection>
      )} */}

      {/* Member Filter (for admins/owners) */}
      {isAdmin && (
        <InputWithLabelSection style={{ minWidth: "240px" }}>
          <FilterLabel>{t("assignee")}</FilterLabel>
          <AddSingleMemberDropdown
            updateState={person => onMemberSelect(person)}
            clearAssignee={clearMember}
            assigneeManage={selectedMember}
            membersList={organizationMembersList}
            page="jobs_in_map"
            closeDisabled={true}
          />
        </InputWithLabelSection>
      )}
    </JobsInMapFilterContainer>
  );
};

export default JobsInMapFilter;